/**
 * 06-24-2019
 * This class helps communicate results and errors after web1 json ajax
 * requests.
 * ~~ Scott Johnson
 */

/** List jshint ignore directives here. **/
/* jshint undef: true, unused: true */
/* jshint browser:true */

/**
 * //[ Begin Example

   var onRequestResult = function( oError, oResult, cName ){
      if ( oError ) {
         App.alert( oError.message, cName.concat( ' Failure' ) );
         return;
      }// /if()

      if ( oResult.response == 'error' ) {
         App.alert( oResult.message, cName.concat( ' Error' ) );
         return;
      }

   };// /onRequestResult()

   var oResult = $.web1Result( 'UpdatePollQuestion.wr', onRequestResult );

   $.ajax({
      url: '/request.wr',
      dataType: 'json',
      success: function( result ){
         oResult.send( 'result', result );
      },// /success()

      error: function( oXhr, cStatus, cError ){
         oResult.send( 'error', Array.prototype.slice.call( arguments ) );
      }// /error()
   });
   * // End Example ]
   * ~~ Scott Johnson
   */

/**
 * @constructor
 */
const web1Result = function( cName, oContext ){
   var deferred = {};
   const o_promise = new Promise(function( resolve, reject ){
      deferred.resolve = resolve;
      deferred.reject = reject;
   });
   
   var self = {
      _error: null,
      _result: null,
      name: cName,
      context: oContext || window,
      deferred: deferred,
      promise: o_promise,

      success: function( result ){
         self.reply( 'result', result );
      },// /success()

      error: function( /* oXhr, cStatus, cError */ ){
         self.reply( 'error', Array.prototype.slice.call( arguments ) );
      },// /error()



      /**
       * This method sends the final results/error back to the callback function.
       */
      reply: function( cType, oData ) {

         switch( cType ){
            case 'error':
               this._error = {
                  xhr: oData[0],
                  status: oData[1],
                  error: oData[2]
               };// /error{}

               switch ( true ) {
                  case this._error.status == 'parsererror':
                     // The data received is not valid json.
                     if ( !this._error.xhr.responseText ) {
                        // The data received from the server was empty.
                        this._error.message = 'No response from server after '.concat(
                           this.name,'. Please try again.',
                           ' If you continue to exerience this error, please contact your account administrator.' );
                     }
                     else {
                        /**
                         * The data received from the server was NOT empty, but not
                         * valid JSON.
                         */
                        this._error.message = 'Invalid response from server after '.concat( this.name, '.\n', this._error.xhr.responseText );
                     }
                     break;

                  case this._error.status == 'error' && this._error.error === '':
                     // This probably happend while reloading the page or some other abort.
                     return;

                  default:
                  // Unanticipated error
                  this._error.message = 'Unanticipated ajax error after '.concat( this.name, ': ', this._error.error );
               }// /switch()

               //this.deferred.reject([ this._error, this._result, this.name ]);
               break;

            case 'result':
               this._result = oData;
               break;

            default:
               throw '"'.concat( cType, '" is an invalid JSONResult type' );
         }// /switch()
         
         this.deferred.resolve([ this._error, this._result, this.name ]);
      }// /reply()

   };// /self{}


   return self;
};// /web1Result()

// module.exports = web1Result;
export default web1Result;
